export function EmptyState({ icon: Icon, title, body, action, testid }) {
  return (
    <div data-testid={testid || "empty-state"} className="flex flex-col items-center justify-center py-14 text-center">
      {Icon ? (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F6F8FA] text-[#43535E]">
          <Icon className="h-6 w-6" />
        </div>
      ) : null}
      <h3 className="font-display text-lg font-semibold text-[#0B2B33]">{title}</h3>
      {body ? <p className="mt-1 max-w-md text-sm text-[#43535E]">{body}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}

export function ErrorState({ title = "Something didn't load", body, onRetry }) {
  return (
    <div data-testid="error-state" className="rounded-xl border border-[#E4E9EF] bg-white p-6 text-center">
      <h3 className="font-display text-base font-semibold text-[#0B2B33]">{title}</h3>
      {body ? <p className="mt-1 text-sm text-[#43535E]">{body}</p> : null}
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          data-testid="retry-button"
          className="mt-4 rounded-full border border-[#E4E9EF] px-4 py-2 text-sm font-semibold text-[#0B2B33] hover:bg-[#F6F8FA]"
        >
          Try again
        </button>
      ) : null}
    </div>
  );
}

export function LoadingBlock({ rows = 3 }) {
  return (
    <div data-testid="loading-block" className="animate-pulse space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-14 rounded-lg bg-[#F6F8FA]" />
      ))}
    </div>
  );
}
